import { useState, useEffect, useCallback } from 'react'
import { useGameStore } from '@/store/gameState'
import { Layout } from '@/components/Layout'
import { FocusView } from '@/components/FocusView'
import { ExploreView } from '@/components/ExploreView'
import { CodexView } from '@/components/CodexView'
import { ResultModal } from '@/components/ResultModal'
import { useExploreNotification } from '@/hooks/useTimerNotification'
import { PLACES } from '@/data/places'
import './App.css'

export type ViewType = 'focus' | 'explore' | 'codex'

export default function App() {
  const [activeView, setActiveView] = useState<ViewType>('focus')
  const pending = useGameStore((s) => s.pending)
  const clearPending = useGameStore((s) => s.clearPending)
  const reconcile = useGameStore((s) => s.reconcile)

  const getPlaceName = useCallback((placeId: string) => {
    return PLACES[placeId]?.name || placeId
  }, [])

  // Notify when explore activities (hunt/travel) complete
  useExploreNotification(pending, getPlaceName)

  useEffect(() => {
    reconcile()
    const interval = setInterval(reconcile, 5000)
    return () => clearInterval(interval)
  }, [reconcile])

  return (
    <Layout activeView={activeView} onViewChange={setActiveView}>
      <div className="views-container">
        {activeView === 'focus' && <FocusView />}
        {activeView === 'explore' && <ExploreView />}
        {activeView === 'codex' && <CodexView />}
      </div>

      {pending && (
        <ResultModal
          result={pending}
          onClose={clearPending}
        />
      )}
    </Layout>
  )
}
